export enum TokenType {
  nft = 'NFT',
  noType = 'noType',
  erc20 = 'ERC20',
  erc721 = 'ERC721',
  erc1155 = 'ERC1155',
}
